export class OrganizationUserResetPasswordRequest {
    newMasterPasswordHash: string;
    key: string;
}
